const HiddenHeading = ({ content }) => {
  return content?.title ? <h1 className="sr-only">{content?.title}</h1> : null;
};

export default HiddenHeading;
